var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNodata24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.25,
    viewBox: "0 0 18 12.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_nodata24x24",
    transform: "translate(0 .25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 9,
    cy: 2,
    rx: 9,
    ry: 2,
    transform: "translate(0 8)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(2.7)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M21.8,3.791,18.977.377A.659.659,0,0,0,18.435,0h-6.07a.66.66,0,0,0-.542.377L9,3.828V6.6H21.8Z",
    transform: "translate(-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M18.075,13.879c0-.481.277-.879.62-.879H21.8v5.441c0,.637-.367,1.159-.821,1.159H9.821C9.367,19.6,9,19.078,9,18.441V13h3.105c.343,0,.62.4.62.878v.007c0,.482.28.87.622.87h4.1c.343,0,.622-.392.622-.874Z",
    transform: "translate(-9 -9.1)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNodata24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_nodata24x24.d038a859ef7428af567e71e85b7012a1.svg";